module.exports = __webpack_public_path__ + "static/media/Vanilluxe_gaussian2.12a28470.png";